import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';

export default (props: any) => {
  const { isNormal, setNormal, children } = props;
  return <div className="navmenu-hd">
    {isNormal ?
      <div className="navmenu-hd-title">{children}</div> :
      <div className="header-width" onClick={() => {
        setNormal(true);
      }}>
        <SvgIcon className="header-width-title" type="merit" />
      </div>
    }
  </div>
}
